import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Home from './components/home';
import Dashboard from './components/dashbboard';
import Layout from './components/layout';
import Product from './components/product';
import User from './components/users';
import Login from './components/login';
import addProduct from './components/addProduct';
import ProductImages from './components/productImages';
import AddEditProductImage from './components/addEditProductImage';
import AddUser from './components/addUser';
import './assets/css/animate.min.css';
import './assets/css/animation.css';
import './assets/css/bootstrap-select.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './assets/css/style.css';
import { ToastContainer } from "react-toastify";
import AddEditSlider from './components/addEditSlider';
import Slider from './components/slider';
import Inquiry from './components/inquiry';
import AboutDetail from './components/aboutDetail';
import Category from './components/category';
import AddEditCategory from './components/addEditCategory';

function PrivateRoute({ component: Component, ...rest }) {
  const isLoggedIn = !!localStorage.getItem('user_data'); // Example: check if user is logged in
  return (
    <Route
      {...rest}
      render={(props) =>
        isLoggedIn ? (
          <Layout>
            <Component {...props} />
          </Layout>
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
}

function App() {
  return (
    <>
     <ToastContainer
        position="top-right"
        autoClose={3000} // closes after 3 seconds
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
         className="custom-toast"
      />
    <Router>
      <Switch>
        {/* Public route */}
        <Route exact path="/login" component={Login} />
        {/* Private routes */}
        <PrivateRoute exact path="/" component={Home} />
        <PrivateRoute path="/about-detail" component={AboutDetail} />
        <PrivateRoute path="/dashboard" component={Dashboard} />
        <PrivateRoute path="/product" component={Product} />
        <PrivateRoute path="/category" component={Category} />
        <PrivateRoute path="/users" component={User} />
        <PrivateRoute path="/product-images" component={ProductImages} />
        <PrivateRoute path="/add-product" component={addProduct} />
        <PrivateRoute path="/add-edit-product" component={AddEditProductImage} />
         <PrivateRoute path="/sliders" component={Slider} />
          <PrivateRoute path="/inquiry" component={Inquiry} />
        <PrivateRoute path="/add-edit-slider" component={AddEditSlider} />
         <PrivateRoute path="/add-edit-category" component={AddEditCategory} />
        <PrivateRoute path="/add-user" component={AddUser} />

        {/* 404 fallback */}
        <Route render={() => <h1>404 - Not Found</h1>} />
      </Switch>
    </Router>
    </>
  );
}

export default App;
